export default "__VITE_ASSET__CwUrm0dG__"